import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Palette, RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getPalette, DEFAULT_PALETTE } from "@/lib/palette";

export function PaletteSection() {
  const { company, refresh } = useAuth();
  const [items, setItems] = useState(() => getPalette(company));
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => { if (!dirty) setItems(getPalette(company)); }, [company, dirty]);

  const update = (i, patch) => { setDirty(true); setItems((arr) => arr.map((it, idx) => (idx === i ? { ...it, ...patch } : it))); };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/company/color-palette", { items });
      toast.success("Kleuren opgeslagen");
      setDirty(false);
      if (refresh) await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kon kleuren niet opslaan");
    } finally { setSaving(false); }
  };

  return (
    <section className="pb-card p-5" data-testid="settings-palette">
      <div className="flex items-center gap-2 mb-1">
        <Palette size={20} className="text-orange-600"/>
        <h2 className="pb-heading text-xl font-black">Kleuren &amp; betekenis</h2>
      </div>
      <p className="text-sm text-slate-600 font-medium mb-4">
        Geef elke kleur een betekenis (bijv. Schouwen, Glas plaatsen, Spoed). Deze 10 kleuren kies je met één klik bij een project, en ze staan als legenda onder het planbord.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-2 border-2 border-slate-200 rounded p-2" data-testid={`palette-row-${i}`}>
            <input type="color" value={it.color} onChange={(e) => update(i, { color: e.target.value.toUpperCase() })} className="w-10 h-10 rounded border-2 border-slate-900 cursor-pointer shrink-0" data-testid={`palette-color-${i}`}/>
            <input className="pb-input !min-h-[40px]" maxLength={30} placeholder={`Kleur ${i + 1}`} value={it.name} onChange={(e) => update(i, { name: e.target.value })} data-testid={`palette-name-${i}`}/>
          </div>
        ))}
      </div>
      <div className="flex justify-between gap-2 mt-4">
        <button type="button" className="pb-btn-outline flex items-center gap-1" onClick={() => { setDirty(true); setItems(DEFAULT_PALETTE); }} data-testid="palette-reset">
          <RotateCcw size={14}/> Standaard
        </button>
        <button type="button" className="pb-btn-primary" onClick={save} disabled={saving} data-testid="palette-save">
          {saving ? "Opslaan…" : "Opslaan"}
        </button>
      </div>
    </section>
  );
}
